module.exports = __webpack_public_path__ + "static/bridge-26c914a42b6489eb98dc76afe3087e05.png";